import { render, staticRenderFns } from "./gamePage.vue?vue&type=template&id=5f6fc7fd&scoped=true"
import script from "./gamePage.vue?vue&type=script&lang=js"
export * from "./gamePage.vue?vue&type=script&lang=js"
import style0 from "./gamePage.vue?vue&type=style&index=0&id=5f6fc7fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6fc7fd",
  null
  
)

export default component.exports